<template>
<main class="bg-main">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>

  <section class="container">

     <div class="heading-content-title">
      {{ $t('lesson.grammar.title') }}
    </div>

    <div class="buttons-at-the-bottom">

      <div class="player-grammar">
        <vue-plyr ref="plyr" :key="$route.params.lesson_id" :options="playerOptions" name="player-grammar">
          <video id="videoplayer" playsinline crossorigin :data-poster="grammarData.content.poster">
            <source>
            <track kind="captions" label="Japanese" srclang="ja" :src="grammarData.content.subtitles" v-if="grammarData.content.subtitles" default>
            <track kind="captions" label="English" srclang="en" :src="grammarData.content.en_subtitles" v-if="grammarData.content.en_subtitles">
            <track kind="captions" label="Nepali" srclang="np" :src="grammarData.content.np_subtitles" v-if="grammarData.content.np_subtitles">
            <track kind="captions" label="Vietnamese" srclang="vn" :src="grammarData.content.vn_subtitles" v-if="grammarData.content.vn_subtitles">
            <track kind="captions" label="Thai" srclang="th" :src="grammarData.content.th_subtitles" v-if="grammarData.content.th_subtitles">
            <track kind="captions" label="Indonesian" srclang="id" :src="grammarData.content.id_subtitles" v-if="grammarData.content.id_subtitles">
            <track kind="captions" label="Spanish" srclang="es" :src="grammarData.content.es_subtitles" v-if="grammarData.content.es_subtitles">
            <track kind="captions" label="Portuguese" srclang="pt" :src="grammarData.content.pt_subtitles" v-if="grammarData.content.pt_subtitles">
            <track kind="captions" label="Korean" srclang="kr" :src="grammarData.content.kr_subtitles" v-if="grammarData.content.kr_subtitles">
            <track kind="captions" label="China" srclang="cn" :src="grammarData.content.cn_subtitles" v-if="grammarData.content.cn_subtitles">
            <track kind="captions" label="Taiwan" srclang="tw" :src="grammarData.content.tw_subtitles" v-if="grammarData.content.tw_subtitles">
            <track kind="captions" label="Russian" srclang="ru" :src="grammarData.content.ru_subtitles" v-if="grammarData.content.ru_subtitles">
            <track kind="captions" label="Ukraine" srclang="ua" :src="grammarData.content.ua_subtitles" v-if="grammarData.content.ua_subtitles">
          </video>
        </vue-plyr>
      </div>

      <div class="buttons-side-by-side">
      <a class="button button-default back" @click="back">{{ $t('common.button.back') }}</a>
      <a class="button button-primary next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

    </div>

  </section>

</main>

</template>

<script>
  import {appEnv} from './../../config';
  import learningLog from '../../mixins/learning-log';
  import status from '../../mixins/status';
  import {mapState} from 'vuex';
  import Hls from 'hls.js';

  import Vue from 'vue';
  import VuePlyr from 'vue-plyr'
  // Vue Plyr Player
  Vue.use(VuePlyr)

  import 'vue-plyr/dist/vue-plyr.css';

  import componentContentHead from '../shared/ContentHead.vue';

  export default {
    name: 'LessonGrammar',
    components: {
      'contenthead': componentContentHead,
    },
    mixins: [
      learningLog,
      status
    ],
    data () {
      return {
        step: 'grammar',
        playerOptions: {
          controls: [
            'play-large', // The large play button in the center
            // 'restart', // Restart playback
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions
            'settings', // Settings menu
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen' // Toggle fullscreen
          ]
        },
        authUser: null,
        storage: {},

      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      grammarData() {
         return this.$store.getters.lesson_content.grammar ? this.$store.getters.lesson_content.grammar : {content: { title: '', body: ''}}
      },
    },

    created() {

      this.authUser = this.$store.getters.getAuthUser;

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
        this.$router.push({name: 'lesson.introduction'});
      }

    },

    mounted() {
      const self = this

      const videoPlayer = document.getElementById('videoplayer');
      videoPlayer.addEventListener('webkitbeginfullscreen webkitendfullscreen', event => {
        if(event.type === 'webkitbeginfullscreen') {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'block');
        } else {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'none');
        }
      });
      // Set video path
      if (Hls.isSupported() && appEnv === 'production') {
        const hlsConfig = {
          firstLevel: 3,
          firstAutoLevel: 3,
          startLevel: 3,
          manifestLoadingTimeOut: 3000, // マスターマニフェストのタイムアウト(ミリ秒)
          manifestLoadingMaxRetry: 10, // マスターマニフェストを何回リトライするか
          manifestLoadingMaxRetryTimeout: 3000, // タイムアウトしたあとリトライするまでの最大待機時間(ミリ秒)
          levelLoadingTimeOut: 3000, // レベルマニフェストのタイムアウト(ミリ秒)
          levelLoadingMaxRetry: 10, // レベルマニフェストを何回リトライするか
          levelLoadingMaxRetryTimeout: 3000, // タイムアウトしたあとリトライするまでの最大待機時間(ミリ秒)
          fragLoadingTimeOut: 3000, // 動画データのタイムアウト(ミリ秒)
          fragLoadingMaxRetry: 10, // 動画データを何回リトライするか
          fragLoadingMaxRetryTimeout: 3000, // 動画データがタイムアウトしたあとリトライするまでの最大待機時間(ミリ秒)
          liveBackBufferLength: 0, // 再生し終わったデータを保持する長さ(秒)
        };
        const hls = new Hls(hlsConfig);
        hls.loadSource(this.grammarData.content.movie);
        hls.attachMedia(videoPlayer);


      } else {
        const source = document.getElementsByTagName('source')[0];
        source.setAttribute("src", this.grammarData.content.movie);

        videoPlayer.load();

      }
    },
    methods: {
      nextStep() {
        if (this.$store.getters.lesson_content[this.step].status != 'completed') {
          this.statusContent('completed', this.step);
          this.$store.dispatch('updateLessonContentStatus', {type: 'grammar', status: 'completed' });
        }
        this.learningTempLog();
        this.learningLog();

        this.$router.push({name: 'lesson.explanation', params: {step: 'practice'}});
      },
      back() {
        this.$router.push({name: 'lesson.introduction'});
      },
    },
  }
</script>
